import { uniqueAndSorted } from "@faire/retailer-visitor-shared/lib/uniqueAndSorted";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";

export const createCategoryPageFiltersQueryKeys = ({
  navigationPath,
  filterKeys,
  requestReferrer,
}: {
  navigationPath: string;
  filterKeys: string[];
  requestReferrer: ISearchRequestReferrer;
}) => {
  return [navigationPath, uniqueAndSorted(filterKeys), requestReferrer];
};
